<template>
  <div>
    <h1>Entrez votre code de confirmation.</h1>
    <form @submit.prevent="handleSubmit">
      <div>
        <FormAuthCode v-model="form.authCode" :error="badAuthCode" />
      </div>

      <p class="description">
        Vous allez recevoir le code par SMS sur votre téléphone au <strong>{{ form.mobilePhone }}</strong>
      </p>

      <p v-if="badAuthCode" class="error">Le code est incorrect</p>

      <AuthCodeResendLink :auth-code="form.authCode" :signup-mobile-phone="form.mobilePhone" />

      <SignupButtons :can-be-submitted="!$v.$invalid" :is-submitting="isSubmitting" />
    </form>
  </div>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen';
  import FormAuthCode from '@/components/Form/FormAuthCode';
  import AuthCodeResendLink from '@/components/AuthCodeResendLink';
  import SignupButtons from '@/components/Signup/SignupButtons';
  import { maxLength, minLength, required } from '@byscripts/vuelidate/lib/validators';
  import Auth from '@/api/auth';
  import { getAuthorizeURL } from '@/helpers/tools';

  export default {
    name: 'SignupAuthCode',
    components: { SignupButtons, AuthCodeResendLink, FormAuthCode, ButtonGreen },
    data() {
      return {
        isSubmitting: false,
        badAuthCode: false,
        signupError: false,
        form: {
          authCode: null,
        },
      };
    },
    validations: {
      form: {
        authCode: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(6),
        },
      },
    },
    methods: {
      async handleSubmit() {
        this.badAuthCode = false;

        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError('Veuillez vérifier le formulaire');
        }

        try {
          this.isSubmitting = true;
          this.signupError = false;

          await this.$store.dispatch('signup/saveForm', { form: this.form });
          await this.$store.dispatch('signup/register');

          const { email, password } = this.$store.getters['auth/getCredentials'];
          await Auth.login(email, password);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event' : 'subscription_hubspot'
          });

          window.lintrk = window.lintrk || (() => {});
          window.lintrk('track', { conversion_id: 5328204 });

          window.location = getAuthorizeURL();
        } catch (e) {
          this.isSubmitting = false;
          if (e.response?.status === 400) {
            this.form.authCode = null;
            return this.badAuthCode = true;
          }
          await this.$addError('Une erreur s\'est produite. Veuillez réessayer.');
          throw e;
        }
      },
    },
  };
</script>

<style scoped>

</style>
